import { ref } from 'vue'

export const apiBaseUrl = process.env.VUE_APP_API_BASE_URL
export const isLoading = ref<boolean>(false)

export const organization = ref<any>({})
export const organizationSettings = ref<any>({})

export const cart = ref<any>(JSON.parse(localStorage.getItem('cart') as string) ? JSON.parse(localStorage.getItem('cart') as string) : [])
export const commands = ref<any>({}) // Mapping table number -> Tab[]
export const selectedCommand = ref<any>(null)
export const categories = ref<any | null>(null)
export const selectedProduct = ref<any>({})
export const products = ref<any[]>([])
export const me = ref<any>({})
export const orders = ref<any[]>([])